import { State } from '@/store/modules/global/user/user.store';

const getters = {
  getUserInfo(state: State) {
    const userInfo = {
      firstName: state.user.firstName,
      lastname: state.user.lastName,
      email: state.email,
    };
    return userInfo;
  },
  getAccessForOap(state: State) {
    return state.oapAccessToken;
  },
  getTeamId(state: State) {
    return state.teamID;
  },
  getTeamName(state: State) {
    return state.teamName;
  },
  getPrevTeamData(state: State) {
    return state.prevTeamData;
  },
  getUserType(state: State) {
    return state.userType;
  },
  getDashboard(state: State) {
    return state.dashboard;
  },
  getLoginCount(state: State) {
    return state.loginCount;
  },
  getUserLastLogin(state: State) {
    return state.lastLogin;
  },
  getUserRoleId(state: State) {
    return state.roleId;
  },
  getUserRoleName(state: State) {
    return state.roleName;
  },
  getIsUserAdmin(state: State) {
    return state.isRoleValid;
  },
};

export default getters;
